import React from 'react'

function Ride() {
  return (
    <div>
      b6
    </div>
  )
}

export default Ride
